import { render } from "./ChartHeaderDockView.vue?vue&type=template&id=7b25fbc1&scoped=true&ts=true"
import script from "./ChartHeaderDockView.vue?vue&type=script&lang=ts"
export * from "./ChartHeaderDockView.vue?vue&type=script&lang=ts"

import "./ChartHeaderDockView.vue?vue&type=style&index=0&id=7b25fbc1&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b25fbc1"]])

export default __exports__